module.exports = __webpack_public_path__ + "img/FLSH5.53560336.svg";